import { gql } from '@apollo/client';

export const CHANGELOG_FIELDS = gql`
  fragment ChangeLogFields on ChangeLogItem {
    change
    changeLogId
    createdDateTime
    referenceId
    uid
    userName
  }
`;
